import ViewModelClient from '@engoo/view-model';

export class ExtendedViewModelClient extends ViewModelClient {
  /**
   * Indicates that the union of these types are that of a single canonical
   * type.
   *
   * @param {function[]} types Constructors for entity types.
   */
  bindRelatedTypes(types) {
    // Validate and append types.
    types.forEach((type) => {
      if (type.relatedTypes.length > 1) {
        throw new Error(`Trying to associate ${type.typeName} with multiple union types.`);
      }

      // eslint-disable-next-line no-param-reassign
      type.relatedTypes = types;
    });
  }

  /**
   * @override
   */
  defineClass(...args) {
    const type = super.defineClass(...args);

    // Related types are all types which refer to the same remote database
    // entity. For example, we have both Lesson and LessonHeader but those are
    // different views of the same entity.
    type.relatedTypes = [type]; // Each type has the identity property.

    // Externally associated types are external associations whose contents are
    // instances of this type
    type.externalAssociationTypes = [];

    return type;
  }

  /**
   * @override
   */
  defineExternalAssociation(...args) {
    const externalAssociation = super.defineExternalAssociation(...args);
    externalAssociation.associationType.externalAssociationTypes.push(externalAssociation);
    return externalAssociation;
  }
}

const vmClient = new ExtendedViewModelClient();
export default vmClient;
